import React, { useEffect, useState, useRef,useContext } from 'react';
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';
import { Tooltip } from '../../components/utils/Tooltip';
import { Modal } from '../../components/modal/Modal';
import { useSpinner } from '../../../hooks/useSpinner';
import { UserContext } from '../../../../src/context/provider/UserProvider';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { EstrellaCalificacion } from '../../components/EstrellasCalificacion';
import { useModal } from '../../../hooks/useModal';
import { notify } from '../../../utils/utils';
import { useCalificaciones } from '../../../hooks/useCalificaciones';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { number } from 'yup';



export const Calificaciones =()=>{
    
    const classNameInput = "text-white h-[30px] rounded caret-white px-2 w-full bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    const [isOpenNuevo, openModalNuevo, closeModalNuevo] = useModal()
    const [verInputNuevaEstrella , setVerInputNuevaEstrella ] = useState(false)
    const {
        listarCalificaciones,
        calificaciones,
        guardarEditarEstrellaOpcion,
        estrellaOpcion,
        editarValorEstrellaOpcion,
        editarValorEstrella,
        guardarEditarEstrella,
        estrella
    }= useCalificaciones()
    const [ estrellasSinRepetir, setEstrellasSinRepetir ] = useState()
    
    useEffect(() => {
        listarCalificaciones();      
    }, []);

    useEffect(()=>{
        const nuevasEstrellas = eliminarEstrellasRepetidas(calificaciones);
        setEstrellasSinRepetir(nuevasEstrellas)
    },[calificaciones])

    const abirModalNuevo = ()=> {
        openModalNuevo()
    }

    const limpiarNuevaEstrella=()=>{
        editarValorEstrella("nomEstrella", '')
        editarValorEstrella("cantidadEstrellas", '0')
        setVerInputNuevaEstrella(false)
    }

    const guardarNuevaEstrella  = () =>{
        guardarEditarEstrella()
        setVerInputNuevaEstrella(false)
    }

    const eliminarEstrellasRepetidas = (array) => {
        const uniqueObjects = [];
        const uniqueIds = new Set(); // Usaremos un Set para almacenar los identificadores únicos
    
        array?.forEach((obj) => {
            // Reemplaza "id" con la propiedad única de tu objeto
            if (!uniqueIds.has(obj.codEstrella)) {
            uniqueIds.add(obj.codEstrella);
            uniqueObjects.push(obj);
            }
        });
        
        return uniqueObjects;
    };

    const registarEstrellaDetalle = async () => {
        if (estrellaOpcion.descripcion == ""){
            notify("Debe ingresar una descripción","error")
            return
        }
        const isValid = await guardarEditarEstrellaOpcion();
        if(isValid){
            closeModalNuevo();
            listarCalificaciones();
        }
    }

return(
    <>
        <ContenedorParametros titulo="Registro de Calificaciones">
        <BotonProcesar onClick={() => listarCalificaciones()} ></BotonProcesar>
            <BotonNuevo
                onClick={() => {
                    editarValorEstrellaOpcion("codEstrella", 0);
                    editarValorEstrellaOpcion("descripcion", '');
                    abirModalNuevo();
                }}
            >NUEVO</BotonNuevo>
        </ContenedorParametros>
        <ContenedorTabla>  
            <table className="table ">
                <thead>
                    <tr>
                        <th className="text-center">N</th>
                        <th className="text-center">ESTRELLAS</th>
                        <th className="text-center">CALIFICACIÓN</th>
                        <th className='text-center'>OPCIÓN</th>
                        <th className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                {   
                    calificaciones?.length > 0 
                    ? calificaciones?.map((calificacion, i) => {
                        return (
                            <tr key={++i}>
                                <td className='text-center'>{ ++i}</td>
                                <td className='text-center'>
                                    <EstrellaCalificacion tamaño="xl" cantidadEstrellas={calificacion.cantidadEstrellas}></EstrellaCalificacion>
                                </td>
                                <td className="text-center">{calificacion.nomEstrella}</td>
                                <td className="text-center">{calificacion.descripcion}</td>
                                <td className="text-center w-[10px]" ></td>    
                                

                                
                            </tr>
                        )
                    })
                    : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                }
                </tbody>
            </table>
        </ContenedorTabla>

        <Modal 
            isOpen={isOpenNuevo} closeModal={closeModalNuevo} action={registarEstrellaDetalle}
            title="Registrar Nueva Calificación"
            spinner={{}}
        >
            <div className='w-full'>
                <label> {verInputNuevaEstrella? "Nueva Estrella = Cantidad Estrella - Descripción" : "Elija una Calificacion" }</label>
                <div className='flex gap-2 items-center'>
                    <input
                        type="number"
                        min={0}
                        max={10}
                        className={`${classNameInput} w-[50px] ${verInputNuevaEstrella? '' : ' hidden '}`} 
                        value={estrella.cantidadEstrellas}
                        onChange={(e) => editarValorEstrella("cantidadEstrellas", e.target.value)}
                    />
                    <input
                        className={`${classNameInput} w-[250px] ${verInputNuevaEstrella? '' : ' hidden '}`}
                        value={estrella.nomEstrella}
                        onChange={(e) => editarValorEstrella("nomEstrella", e.target.value)}
                    />
                    <select
                        className={`${classNameInput} containerScroll w-[300px] ${verInputNuevaEstrella? 'hidden':''}`}
                        onChange={(e) => editarValorEstrellaOpcion("codEstrella", e.target.value)}
                    >
                        <option value={0} key={0}>--Seleccione--</option>
                        {
                            estrellasSinRepetir?.map((calificacion,i)=>(
                                <option key={calificacion.codEstrella} value={calificacion.codEstrella}>{calificacion.nomEstrella}</option>
                            ))
                        }
                    </select>
                    <button
                        className={` fa ${verInputNuevaEstrella? 'fa-check' : 'fa-plus-circle'} hover:text-green-400 text-green-500 text-2xl`}
                        onClick={()=>{verInputNuevaEstrella? guardarNuevaEstrella() : setVerInputNuevaEstrella(true)  }}
                    ></button>
                    <button
                        className={`fa fa-light ${verInputNuevaEstrella? 'fa-trash':'hidden'} hover:text-red-500 text-red-800 text-2xl`}
                        onClick={()=>{limpiarNuevaEstrella()}}
                    ></button>
                </div>
                <label className=''>Ingrese descripción</label>
                <textarea
                    autoFocus={true} 
                    className={`${classNameInput} h-[70px] w-full text-[15px] py-3 resize-none`}
                    value={estrellaOpcion.descripcion}
                    onChange={(e) => editarValorEstrellaOpcion("descripcion", e.target.value)}
                />
            </div>
        </Modal>


    </>


)


}